export default __webpack_public_path__ + "static/media/studio-1.56c6121d.jpg";